import ApplicationController from './application_controller'
import { createPopper } from '@popperjs/core'

export default class extends ApplicationController {

	static targets = [
		'focusElement',
		'popperElement',
	]

	static values = {
		marginTop: { type: String, default: '0' },
		placement: { type: String, default: 'bottom-start' },
		targetId: { type: String }
	}

	connect() {
		if (!this.hasPopperElementTarget && !this.targetIdValue) { console.error('Missing popper element reference in Stimulus PopperController.') }
		this.initPopper()
	}

	disconnect() {
		this.popper.destroy()
	}

	getPopperElement() {
		if (this.hasPopperElementTarget) { return this.popperElementTarget }
		else { return document.getElementById(this.targetIdValue) }
	}

	initPopper() {
		this.popper = createPopper(this.focusElementTarget, this.getPopperElement(), { placement: this.placementValue })
	}
	
	elementFocused(_event) {
		const popperElement = this.getPopperElement()
		popperElement.classList.remove('d-none')
		popperElement.setAttribute('data-show', '')
		this.popper.update();
	}

	elementToggle(event) {
		const popperElement = this.getPopperElement()
		if (popperElement.classList.contains('d-none')) {
			popperElement.classList.remove('d-none')
			popperElement.setAttribute('data-show', '')
		} else {
			popperElement.classList.add('d-none')
			popperElement.removeAttribute('data-show')
		}
	}

	elementBlurred(event) {
		const popperElement = this.getPopperElement()
		popperElement.classList.add('d-none')
		popperElement.removeAttribute('data-show')
	}

	clickItem(event) {
		event.currentTarget.click()
	}

}

